/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { AnyAction } from 'redux';
import { ScreenControllerTypes } from '../../core/navigation/ScreenControllerTypes';
import { Log } from '../../core/logging/Log';
import { ON_KEY_EVENT, ON_MOUSE_EVENT } from './inputfactory.types';
import {
    onKeyBackGuide,
    onKeyChannelDownGuide,
    onKeyChannelUpGuide,
    onKeyColorBlueGuide,
    onKeyDashGuide,
    onKeyDigitGuide,
    onKeyDownGuide,
    onKeyInfoGuide,
    onKeyLeftGuide,
    onLongKeyOkGuide,
    onKeyOkGuide,
    onKeyRightGuide,
    onKeyUpGuide,
    onMouseClickGuide,
    onMouseOkLongPressStartGuide,
    onMouseOkLongPressStopGuide,
    onMouseOutGuide,
    onMouseOverGuide,
    onMouseWheelGuide,
    onKeyPlayGuide,
    onKeyPlayPauseGuide,
    onLongKeyChannelDownStartGuide,
    onLongKeyChannelUpStartGuide,
    onLongKeyUpStartGuide,
    onLongKeyDownStartGuide,
} from '../guide/guidenavigation/guidenavigation.reducers';
import {
    clearLongPressIntervalVideoPlayerUi,
    onKeyAdvanceVideoPlayerUi,
    onKeyBackVideoPlayerUi,
    onKeyChannelDownVideoPlayerUi,
    onKeyChannelUpVideoPlayerUi,
    onKeyDigitVideoPlayerUi,
    onKeyDownVideoPlayerUi,
    onKeyFastForwardVideoPlayerUi,
    onKeyGuideVideoPlayerUi,
    onKeyInfoVideoPlayerUi,
    onKeyLongLeftVideoPlayerUi,
    onKeyLeftVideoPlayerUi,
    onKeyOkVideoPlayerUi,
    onKeyPauseVideoPlayerUi,
    onKeyPlayPauseVideoPlayerUi,
    onKeyPlayVideoPlayerUi,
    onKeyReplayVideoPlayerUi,
    onKeyRewindVideoPlayerUi,
    onKeyLongRightVideoPlayerUi,
    onKeyRightVideoPlayerUi,
    onKeyStopVideoPlayerUi,
    onKeyTivoVideoPlayerUi,
    onKeyUpVideoPlayerUi,
    onMouseClickVideoPlayerUi,
    onMouseOverVideoPlayerUi,
    onMouseOutVideoPlayerUi,
    onLongKeyOkVideoPlayerUi,
    onKeyExitVideoPlayerUi,
} from '../videoplayerui/videoplayeruinavigation.reducers';
import { stopGuidePageScroll, stopTurboScroll } from '../guide/turboscroll/turboscroll.reducers';
import {
    onKeyBackSettings,
    onKeyDownSettings,
    onKeyUpSettings,
    onKeyRightSettings,
    onKeyOkSettings,
    onKeyLeftSettings,
    onKeyGuideSettings,
    // __START_DEBUG_CODE_CLEANUP__
    onKeyDigitSettings,
    // __END_DEBUG_CODE_CLEANUP__
    onMouseClickSettings,
    onMouseOutSettings,
    onMouseOverSettings,
} from '../settings/settingsnavigation/settingsnavigation.reducers';
import {
    onKeyBackAntiburnOsd,
    onKeyGuideAntiburn,
    onKeyOkAntiburnOsd,
    onMouseOverAntiburnOsd,
} from '../antiburnosd/antiburnosd.reducers';
import {
    onKeyBackSignIn,
    onKeyDownSignIn,
    onKeyOkSignIn,
    onKeyUpSignIn,
    onMouseClickSignIn,
    onMouseOutSignIn,
    onMouseOverSignIn,
} from '../signin/signinnavigation.reducers';
import {
    onKeyOkErrorScreen,
    onKeyOkSos,
    onMouseClickError,
    onMouseOutErrorScreen,
    onMouseOverError,
} from '../error/error.reducers';
import { onKeyOkSplashScreen } from '../splashscreen/splashscreen.reducers';

const TAG = 'inputFactory';

const initialState: {
    key: string;
    code: string;
    identity: number;
    eventType: string;
    value: any;
} = {
    key: '',
    code: '',
    identity: 0,
    eventType: '',
    value: undefined,
};

const inputFactoryReducer = (state = initialState, { type, payload } = <AnyAction>{}) => {
    const id = state.identity + 1;
    switch (type) {
        case ON_KEY_EVENT:
            return { ...state, key: payload.key, code: payload.code, identity: id };
        case ON_MOUSE_EVENT:
            return {
                ...state,
                eventType: payload.eventType,
                value: payload.value,
                identity: id,
            };
        default:
            return state;
    }
};

export const onKeyRight = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(onKeyRightGuide());
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyRightVideoPlayerUi());
            break;

        case ScreenControllerTypes.SETTINGS_SCREEN:
            dispatch(onKeyRightSettings());
            break;

        default:
    }
};

export const onLongRightStart = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyLongRightVideoPlayerUi());
            break;

        default:
    }
};

export const onLongRightStop = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(clearLongPressIntervalVideoPlayerUi());
            break;

        default:
    }
};

export const onKeyLeft = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(onKeyLeftGuide());
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyLeftVideoPlayerUi());
            break;

        case ScreenControllerTypes.SETTINGS_SCREEN:
            dispatch(onKeyLeftSettings());
            break;

        default:
    }
};

export const onLongLeftStart = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyLongLeftVideoPlayerUi());
            break;

        default:
    }
};

export const onLongLeftStop = () => (dispatch: Function) => {
    dispatch(onLongRightStop());
};

export const onKeyUp = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(onKeyUpGuide());
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyUpVideoPlayerUi());
            break;

        case ScreenControllerTypes.SETTINGS_SCREEN:
            dispatch(onKeyUpSettings());
            break;
        case ScreenControllerTypes.SIGN_IN_SCREEN:
            dispatch(onKeyUpSignIn());
            break;

        default:
    }
};

export const onKeyDown = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(onKeyDownGuide());
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyDownVideoPlayerUi());
            break;

        case ScreenControllerTypes.SETTINGS_SCREEN:
            dispatch(onKeyDownSettings());
            break;

        case ScreenControllerTypes.SIGN_IN_SCREEN:
            dispatch(onKeyDownSignIn());
            break;

        default:
    }
};

export const onKeyOk = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(onKeyOkGuide());
            break;

        case ScreenControllerTypes.SETTINGS_SCREEN:
            dispatch(onKeyOkSettings());
            break;

        case ScreenControllerTypes.SIGN_IN_SCREEN:
            dispatch(onKeyOkSignIn());
            break;

        case ScreenControllerTypes.SOS_SCREEN:
            dispatch(onKeyOkSos());
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyOkVideoPlayerUi());
            break;

        case ScreenControllerTypes.ANTIBURN_SCREEN:
            dispatch(onKeyOkAntiburnOsd());
            break;

        case ScreenControllerTypes.ERROR_SCREEN:
            dispatch(onKeyOkErrorScreen());
            break;

        case ScreenControllerTypes.SPLASH_SCREEN:
            dispatch(onKeyOkSplashScreen());
            break;

        default:
    }
};

export const onLongOkStart = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(onLongKeyOkGuide());
            break;
        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onLongKeyOkVideoPlayerUi());
            break;
        default:
    }
};

export const onKeyChannelUp = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(onKeyChannelUpGuide());
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyChannelUpVideoPlayerUi());
            break;

        default:
    }
};

export const onKeyChannelDown = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(onKeyChannelDownGuide());
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyChannelDownVideoPlayerUi());
            break;

        default:
    }
};

export const onKeyExit = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    if (screenController === ScreenControllerTypes.VIDEO_PLAYER) {
        dispatch(onKeyExitVideoPlayerUi());
    }
};

export const onKeyGuide = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            Log.i(TAG, 'Already in guide screen');
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyGuideVideoPlayerUi());
            break;

        case ScreenControllerTypes.SETTINGS_SCREEN:
            dispatch(onKeyGuideSettings());
            break;

        case ScreenControllerTypes.ANTIBURN_SCREEN:
            dispatch(onKeyGuideAntiburn());
            break;
        default:
    }
};

export const onKeyInfo = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(onKeyInfoGuide());
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyInfoVideoPlayerUi());
            break;

        default:
    }
};

export const onKeyTivo = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyTivoVideoPlayerUi());
            break;

        default:
    }
};

export const onKeyDigit = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyDigitVideoPlayerUi());
            break;
        case ScreenControllerTypes.GUIDE:
            dispatch(onKeyDigitGuide());
            break;
        case ScreenControllerTypes.SETTINGS_SCREEN:
            // __START_DEBUG_CODE_CLEANUP__
            dispatch(onKeyDigitSettings());
            // __END_DEBUG_CODE_CLEANUP__
            break;

        default:
    }
};

export const onKeyDash = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(onKeyDashGuide());
            break;
        default:
    }
};

export const onKeyBack = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(onKeyBackGuide());
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyBackVideoPlayerUi());
            break;

        case ScreenControllerTypes.SETTINGS_SCREEN:
            dispatch(onKeyBackSettings());
            break;

        case ScreenControllerTypes.ANTIBURN_SCREEN:
            dispatch(onKeyBackAntiburnOsd());
            break;
        case ScreenControllerTypes.SIGN_IN_SCREEN:
            dispatch(onKeyBackSignIn());
            break;

        default:
    }
};

export const onKeyPlay = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(onKeyPlayGuide());
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyPlayVideoPlayerUi());
            break;

        default:
    }
};

export const onKeyStop = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyStopVideoPlayerUi());
            break;

        default:
    }
};

export const onKeyFastForward = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyFastForwardVideoPlayerUi());
            break;

        default:
    }
};

export const onKeyRewind = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyRewindVideoPlayerUi());
            break;

        default:
    }
};

export const onKeyReplay = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyReplayVideoPlayerUi());
            break;

        default:
    }
};

export const onKeyColorBlue = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(onKeyColorBlueGuide());
            break;

        default:
    }
};

export const onKeyAdvance = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyAdvanceVideoPlayerUi());
            break;

        default:
    }
};

export const onKeyPlayPause = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(onKeyPlayPauseGuide());
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyPlayPauseVideoPlayerUi());
            break;

        default:
    }
};

export const onKeyPause = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyPauseVideoPlayerUi());
            break;

        default:
    }
};

export const onLongStartDown = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(onLongKeyDownStartGuide());
            break;

        default:
    }
    Log.i(TAG, 'onLongStartDown');
};

export const onLongStartUp = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(onLongKeyUpStartGuide());
            break;

        default:
    }
    Log.i(TAG, 'onLongStartUp');
};

export const onLongStopDown = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(stopTurboScroll());
            break;

        default:
    }
};

export const onLongStopUp = () => (dispatch: Function) => {
    dispatch(onLongStopDown());
};

export const onLongChannelUpStart = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(onLongKeyChannelUpStartGuide());
            break;

        default:
    }
    Log.i(TAG, 'onLongChannelUpStart');
};

export const onLongChannelDownStart = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(onLongKeyChannelDownStartGuide());
            break;

        default:
    }
    Log.i(TAG, 'onLongChanneldownStart');
};

export const onLongChannelUpStop = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(stopGuidePageScroll());
            break;

        default:
    }
};

export const onLongChannelDownStop = () => (dispatch: Function) => {
    dispatch(onLongChannelUpStop());
};

export const onMouseClick = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.ERROR_SCREEN:
            dispatch(onMouseClickError());
            break;
        case ScreenControllerTypes.GUIDE:
            dispatch(onMouseClickGuide());
            break;
        case ScreenControllerTypes.SETTINGS_SCREEN:
            dispatch(onMouseClickSettings());
            break;
        case ScreenControllerTypes.SIGN_IN_SCREEN:
            dispatch(onMouseClickSignIn());
            break;
        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onMouseClickVideoPlayerUi());
            break;

        default:
    }
};

export const onMouseEnter = () => (dispatch: Function, getState: Function) => {
    Log.i(TAG, 'onMouseEnter');
};

export const onMouseLeave = () => (dispatch: Function, getState: Function) => {
    Log.i(TAG, 'onMouseLeave');
};

export const onMouseOkLongPressStart = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(onMouseOkLongPressStartGuide());
            Log.i(TAG, 'onMouseOkLongPressStart');
            break;
        default:
    }
};

export const onMouseOkLongPressStop = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(onMouseOkLongPressStopGuide());
            Log.i(TAG, 'onMouseOkLongPressStop');
            break;
        default:
    }
};

export const onMouseOut = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.ERROR_SCREEN:
            dispatch(onMouseOutErrorScreen());
            break;
        case ScreenControllerTypes.GUIDE:
            dispatch(onMouseOutGuide());
            break;
        case ScreenControllerTypes.SETTINGS_SCREEN:
            dispatch(onMouseOutSettings());
            break;
        case ScreenControllerTypes.SIGN_IN_SCREEN:
            dispatch(onMouseOutSignIn());
            break;
        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onMouseOutVideoPlayerUi());
            break;
        default:
    }
};

export const onMouseOver = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.ANTIBURN_SCREEN:
            dispatch(onMouseOverAntiburnOsd());
            break;
        case ScreenControllerTypes.ERROR_SCREEN:
            dispatch(onMouseOverError());
            break;
        case ScreenControllerTypes.GUIDE:
            dispatch(onMouseOverGuide());
            break;
        case ScreenControllerTypes.SETTINGS_SCREEN:
            dispatch(onMouseOverSettings());
            break;
        case ScreenControllerTypes.SIGN_IN_SCREEN:
            dispatch(onMouseOverSignIn());
            break;
        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onMouseOverVideoPlayerUi());
            break;

        default:
    }
};

export const onMouseWheel = (wheelDeltaY: number) => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(onMouseWheelGuide(wheelDeltaY));
            break;
        default:
    }
};

export default inputFactoryReducer;
